import script from "./BatchDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchDetail.vue?vue&type=script&setup=true&lang=ts"

import "./BatchDetail.vue?vue&type=style&index=0&id=f9b689c0&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b689c0"]])

export default __exports__